import { Link, useNavigate } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { CONTAINER_URL } from "@/lib/constants";
import { useUserRole } from "@/hooks/useUserRole";
import UserRoleBadge from "@/components/UserRoleBadge";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function Example() {
  const { logOut, user } = useAuth();
  const { userRole, getUserRoleLabel } = useUserRole();
  const navigate = useNavigate();

  const profileImgUrl = user.user.image
    ? `${CONTAINER_URL}/${user.user.image}`
    : `https://app.mecanica.mx/assets/images/app.logo.png`;

  const signOut = async () => {
    await logOut();
    navigate("/auth/login");
  };

  const getProfileLink = () => {
    return user.principalType === "Company"
      ? "/shop/profile"
      : user.principalType === "CustomerApp"
      ? "/customer/profile"
      : "/admin/profile";
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="items-center flex outline-none">
          <span className="w-12 h-12 text-sm text-white bg-slate-200 inline-flex items-center justify-center rounded-full">
            <img
              alt="..."
              className="w-full rounded-full align-middle border-none shadow-lg"
              src={profileImgUrl}
            />
          </span>
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-56">
        {/* Header con información del usuario */}
        <div className="px-2 py-3">
          <p className="text-sm font-medium text-gray-900 truncate">
            {user.user.name || user.user.email}
          </p>
          <p className="text-xs text-gray-500 truncate">{user.user.email}</p>
          {/* Mostrar rol solo para usuarios de tipo 'user' */}
          {user.principalType === "user" && (
            <div className="mt-2">
              <UserRoleBadge role={userRole} />
            </div>
          )}
        </div>

        <DropdownMenuSeparator />

        <DropdownMenuItem asChild>
          <Link to={getProfileLink()}>Mi cuenta</Link>
        </DropdownMenuItem>

        <DropdownMenuItem onClick={signOut}>Cerrar Sesión</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
